<div class="dashboard-content" style="padding: 120px 40px 50px">
  <div class="sdk-applications-page">

    <!-- Header Section -->
    <div class="sdk-header">
      <div class="sdk-icon">
        <i class="fa-solid fa-mobile-screen-button"></i>
      </div>
      <h2>{{ 'sdk-apps.title' | translate }}</h2>
      <p>Create and manage your SDK applications. Generate API keys to integrate with your mobile or web apps.</p>
    </div>

    <!-- Applications Section -->
    <div class="sdk-section" *ngFor="let app of filteredApplications">
      <div class="section-row">
        <div class="section-left">
          <h4>{{ 'sdk-apps.app-name' | translate }}</h4>
          <div class="info-box">
            <span>{{ app.name }}</span>
            <div class="app-badges">
              <span class="platform-badge" [ngStyle]="getPlatformStyle(app.platform)">
                {{ getPlatformLabel(app.platform) }}
              </span>
              <span class="status-badge" [ngStyle]="{'background-color': app.status === 'active' ? '#10B981' : '#6B7280'}">
                {{ app.status === 'active' ? 'Active' : 'Inactive' }}
              </span>
            </div>
          </div>

          <h4 class="mt-4">{{ 'sdk-apps.api-key-mgmt' | translate }}</h4>
          <div class="api-key-box">
            <input type="text" class="form-control"
              [value]="app.api_key || 'Your API Key will appear here'"
              readonly />
            <button class="copy-btn" *ngIf="app.api_key" (click)="copyApiKey(app.api_key)">{{ 'common.copy' | translate }}</button>
          </div>

          <div class="api-key-box mt-3">
            <input type="text" class="form-control"
              [value]="app.application_id || 'Application ID will appear here'"
              readonly />
            <button class="copy-btn" *ngIf="app.application_id" (click)="copyApiKey(app.application_id)">{{ 'common.copy' | translate }}</button>
          </div>

          <!-- Generate Button (only if no key) -->
          <button *ngIf="!app.api_key" class="btn btn-primary mt-3" nz-popconfirm
            nzPopconfirmTitle="Generate API Key for this application?"
            nzPopconfirmPlacement="top"
            (nzOnConfirm)="generateApiKey(app.id)">
            <i class="fa-solid fa-key me-2"></i> {{ 'sdk-apps.generate-api-key' | translate }}
          </button>
        </div>
      </div>
    </div>

    <!-- Empty State / Add New -->
    <div class="sdk-section add-new-section">
      <div class="section-row">
        <div class="section-left">
          <h4>{{ filteredApplications.length > 0 ? ('sdk-apps.add-another' | translate) : ('sdk-apps.create-first' | translate) }}</h4>
          <p class="text-muted">Set up a new SDK application to get your API credentials.</p>
          <button class="btn btn-primary" (click)="openAddDrawer()">
            <i class="fa-solid fa-plus me-2"></i> {{ 'sdk-apps.add-application' | translate }}
          </button>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- Add Application Drawer -->
<nz-drawer [nzVisible]="drawerVisible" [nzWidth]="500" [nzTitle]="drawerTitleTpl" nzPlacement="right"
  [nzClosable]="false" [nzBodyStyle]="{'overflow': 'auto'}" (nzOnClose)="closeDrawer()">

  <ng-template #drawerTitleTpl>
    <div class="d-flex align-items-center gap-2">
      <div class="d-flex justify-content-center align-items-center"
        style="width: 32px; height: 32px; background: linear-gradient(62.82deg, #8F67FD -31.84%, #5304FB 80.32%); box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.09); border-radius: 99px; cursor: pointer;"
        (click)="closeDrawer()">
        <i class="fa-solid fa-angle-left" style="color: #fff;"></i>
      </div>
      <h3 style="font-family: 'Codec Pro'; font-weight: 500; font-size: 18px; line-height: 28px; color: #1E005E; margin: 0;">
        {{ 'sdk-apps.add-application' | translate }}
      </h3>
    </div>
  </ng-template>

  <ng-container *nzDrawerContent>
    <form [formGroup]="applicationForm" (ngSubmit)="submitForm()">
      <div class="luqta-card">
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group">
              <label class="form-label">Application Name<span>*</span></label>
              <input type="text" class="form-control" formControlName="name"
                placeholder="Enter application name" [class.is-invalid]="isFieldInvalid('name')" />
              <small class="text-danger" *ngIf="isFieldInvalid('name')">
                Application name is required
              </small>
            </div>
          </div>

          <div class="col-lg-12">
            <div class="form-group">
              <label class="form-label">Platform<span>*</span></label>
              <select class="form-control custom-select" formControlName="platform" [class.is-invalid]="isFieldInvalid('platform')">
                <option value="">Select Platform</option>
                <option *ngFor="let p of platforms" [value]="p.value">{{ p.label }}</option>
              </select>
              <small class="text-danger" *ngIf="isFieldInvalid('platform')">
                Please select a platform
              </small>
            </div>
          </div>

          <div class="col-lg-12">
            <div class="form-group">
              <label class="form-label">{{ 'common.status' | translate }}</label>
              <div class="select-options">
                <a href="javascript:void(0)" class="option" [class.active]="applicationForm.get('status')?.value === 'active'"
                  (click)="applicationForm.patchValue({status: 'active'})">
                  {{ 'common.active' | translate }}
                </a>
                <a href="javascript:void(0)" class="option" [class.active]="applicationForm.get('status')?.value === 'inactive'"
                  (click)="applicationForm.patchValue({status: 'inactive'})">
                  {{ 'common.inactive' | translate }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end gap-2 mt-4">
        <button type="button" class="btn btn-outline-secondary" (click)="closeDrawer()">{{ 'common.cancel' | translate }}</button>
        <button type="submit" class="btn btn-primary">{{ 'common.create' | translate }}</button>
      </div>
    </form>
  </ng-container>
</nz-drawer>

